<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="邀请码" prop="inviteCode">-->
<!--                <a-input v-model="queryParam.inviteCode" placeholder="请输入邀请码" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->


            <a-col :md="5" :sm="24">
              <a-form-item label="用户真实姓名" prop="realName">
                <a-input v-model="queryParam.realName" placeholder="请输入用户真实姓名" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="5" :sm="24">
              <a-form-item label="邮箱" prop="userEmail">
                <a-input v-model="queryParam.userEmail" placeholder="请输入邮箱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="手机号" prop="userPhone">
                <a-input v-model="queryParam.userPhone" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>

<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="真实姓名" prop="realName">-->
<!--                <a-input v-model="queryParam.realName" placeholder="请输入真实姓名" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <template v-if="advanced">-->


<!--            </template>-->


            <a-col :md="!advanced && 5 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>



          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd(1)" v-hasPermi="['user:distributor:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:distributor:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:distributor:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:distributor:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :scroll="{x:'2000px'}"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
          :rowKey="(record, index) => index + 1"
      >
<!--        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="status" slot-scope="text, record">
          <a-switch checkedChildren="启用" unCheckedChildren="封禁" v-model="record.status == 0" @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="inviteUrl" slot-scope="text, record">
          <a v-if="record.inviteUrl" @click="copyUrl(record.inviteUrl)">{{record.inviteUrl}}</a>
          <div v-else>审核通过后显示</div>
        </span>
        <span slot="giveDiamond" slot-scope="text, record">
          <a v-if="record.giveDiamond">{{record.giveDiamond}}</a>
          <div v-else>0</div>
        </span>

        <span slot="inviteUserUrl" slot-scope="text, record">
          <div v-if="record.inviteUserUrl">
          <a v-if="!record.inviteUserUrl.includes('分销商未激活')" @click="copyUrl(record.inviteUserUrl)">{{record.inviteUserUrl}}</a>
          <div v-if="record.inviteUserUrl.includes('分销商未激活')">{{record.inviteUserUrl}}</div>
          </div>
           <div v-else>审核通过后显示</div>
        </span>

        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['user:distributor:edit']" />-->
          <a v-if="record.applyStatus == 1" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />修改
          </a>
           <a v-if="record.applyStatus == 0 || record.applyStatus == 2" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />审核
          </a>
          <a v-if="record.applyStatus == 1 && record.isActivite == 0" >
<!--            <a-icon type="edit" />激活分销商-->

             <a-popconfirm
               title="确认激活分销商?"
               ok-text="确定"
               cancel-text="取消"
               @confirm="activite(record)"
             >
    <a href="#">激活分销商</a>
  </a-popconfirm>
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:distributor:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:distributor:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"

      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageDistributor, changeStatus, delDistributor, activite} from '@/api/user/distributor'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import auth from "@/plugins/auth";


export default {
  name: 'Distributor',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        inviteUrl: null,
        inviteCode: null,
        userEmail: null,
        userPhone: null,
        distributorRait: null,
        bankName: null,
        bankNo: null,
        realName: null,
        bankAddress: null,
        status: null,
        address: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        // {
        //   title: '用户ID',
        //   dataIndex: 'id',
        //   // ellipsis: true,,
        //   width: '30%',
        //   align: 'center'
        // },
        {
          title: '用户真实姓名',
          dataIndex: 'realName',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'userEmail',
          // ellipsis: true,,
          width: '30%',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '20%',
          // ellipsis: true,,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '是否激活',
          dataIndex: 'isActivite',
          width: '20%',
          customRender: function (t, r, index) {
            if(t == 0) {
              return '未激活'
            }else {
              return '已激活'
            }
          },
          align: 'center'
        },

        {
          title: '手机号',
          dataIndex: 'userPhone',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },
        {
          title: '佣金比例(%)',
          dataIndex: 'distributorRait',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },
        {
          title: '商品佣金比例(%)',
          dataIndex: 'goodsDistributorRait',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },
        {
          title: '邀请二级分销商链接(点击复制)',
          dataIndex: 'inviteUrl',
          scopedSlots: { customRender: 'inviteUrl' },
          width: '20%',
          // ellipsis: true,,
          align: 'center'
        },
        {
          title: '邀请下级用户链接(点击复制)',
          dataIndex: 'inviteUserUrl',
          scopedSlots: { customRender: 'inviteUserUrl' },
          width: '20%',
          // ellipsis: true,,
          align: 'center'
        },
        {
          title: '赠送钻石数',
          dataIndex: 'giveDiamond',
          scopedSlots: { customRender: 'giveDiamond' },
          width: '20%',
          align: 'center'
        },
        {
          title: '邀请码',
          dataIndex: 'inviteCode',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '30%',
          scopedSlots: { customRender: 'createTime' },
          // ellipsis: true,,
          align: 'center'
        },

        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询分销商列表 */
    getList () {
      this.loading = true
     pageDistributor(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },


    activite(record) {
      activite({id: record.id}).then(response => {
        this.$message.success(response.message)
        this.getList()
      })
    },

    copyUrl(url) {


      var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success(
          '复制成功'
      )


    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },

    changeIsOpen (e,record) {
      record.status = e ? 0 : 1
      changeStatus(record).then(response => {
        this.$message.success(
            '操作成功'
        )
        return  record.status = e ? 0 : 1
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        inviteUrl: undefined,
        inviteCode: undefined,
        userEmail: undefined,
        userPhone: undefined,
        distributorRait: undefined,
        bankName: undefined,
        bankNo: undefined,
        realName: undefined,
        bankAddress: undefined,
        nickname: undefined,
        status: undefined,
        ids: undefined,
        address: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        //content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDistributor(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      console.log(that.selectedRows)
      var idsStr = that.selectedRows.map(function(obj,index){
        return obj.id;
      }).join(",");
      that.queryParam.ids = idsStr
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据',
        onOk () {
          that.download('user/user-distributors/export', {
            ...that.queryParam
          }, `分销商_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
